<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="box">
    <div style="height: 60px"></div>
    <van-tabbar :value="active" @change="change">
      <van-tabbar-item icon="home-o" name="/home">首页</van-tabbar-item>
      <!-- <van-tabbar-item name="/service">
        健康
        <template #icon>
          <i class="iconfont icon-jiankang" name="extra"></i>
        </template>
      </van-tabbar-item>  -->
      <!-- <van-tabbar-item icon="medal-o" name="/service">服务</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="friends-o" name="/my">我的</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "tarbar",
  props: {
    active: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    /**123 */
    change(item) {
      // this.$emit("updataActive", item);
      // switch (item) {
      //   case "/home":
      //     jWeixin.miniProgram.reLaunch({
      //       url: "/pages/webview/webview",
      //     });
      //     break;
      //   case "/service":
      //     jWeixin.miniProgram.navigateTo({
      //       url: "/pages/webviewService/webviewService",
      //     });
      //     break;
      //   case "/my":
      //     jWeixin.miniProgram.navigateTo({
      //       url: "/pages/webviewMy/webviewMy",
      //     });
      //     break;
      // }
      this.$router.push(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.van-hairline--top-bottom {
  height: 60px;
  .van-tabbar-item {
    padding-bottom: 10px;
  }
}
</style>
